import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { DockSection, DockSliceState } from './types'
import { tryReducer, initialTryState } from './sections/try'
import { mediaReducer, initialMediaState } from './sections/media'
import { dialogsReducer, initialDialogsState } from './sections/dialogs'
import { commentsReducer, initialCommentsState } from './sections/comments'
import { versionsReducer, initialVersionsState } from './sections/versions'
import { storagesReducer, initialStoragesState } from './sections/storages'

const ALWAYS_TRUE = () => true

const initialState: DockSliceState = {
  openSection: undefined,
  sections: {
    try: initialTryState,
    dialogs: initialDialogsState,
    media: initialMediaState,
    storages: initialStoragesState,
    versions: initialVersionsState,
    comments: initialCommentsState
  }
}

const slice = createSlice({
  name: 'dock',
  initialState,
  reducers: {
    openDock: (state, action: PayloadAction<DockSection>) => {
      state.openSection = action.payload
    },
    closeDock: state => {
      state.openSection = undefined
    },
    toggleDock: (state, action: PayloadAction<DockSection>) => {
      if (state.openSection === action.payload) {
        state.openSection = undefined
        return
      }

      state.openSection = action.payload
    }
  },
  extraReducers: builder =>
    builder
      .addMatcher(ALWAYS_TRUE, (state, action) => {
        state.sections.try = tryReducer(state.sections.try, action)
      })
      .addMatcher(ALWAYS_TRUE, (state, action) => {
        state.sections.media = mediaReducer(state.sections.media, action)
      })
      .addMatcher(ALWAYS_TRUE, (state, action) => {
        state.sections.dialogs = dialogsReducer(state.sections.dialogs, action)
      })
      .addMatcher(ALWAYS_TRUE, (state, action) => {
        state.sections.comments = commentsReducer(state.sections.comments, action)
      })
      .addMatcher(ALWAYS_TRUE, (state, action) => {
        state.sections.versions = versionsReducer(state.sections.versions, action)
      })
      .addMatcher(ALWAYS_TRUE, (state, action) => {
        state.sections.storages = storagesReducer(state.sections.storages, action)
      })
})

export const actions = slice.actions
export const reducer = slice.reducer
